<template>
  <v-select
      solo
      clearable="clearable"
      flat
      :label="label"
      :height="height"
      :items="items"
      :item-text="itemText"
      :item-value="itemValue"
      menu-props="offsetY"
      :class="[ 'custom-textfield-theme-' + theme ]"
      :hide-details="hideDetails"
      :placeholder="placeholder"
      :value="value"
      @change="eventChange"
  ></v-select>
</template>

<script>
export default {
  name: "SelectBox",
  props: {
    label: {
      default: ''
    },
    placeholder: {
      default: ''
    },
    clearable:{
      default: false
    },
    height: {
      default: '36'
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    theme: {
      default: '1'
    },
    items: {
      default: () => ([])
    },
    itemText: {
      default: undefined
    },
    itemValue: {
      default: undefined
    },
    value: {
      default: undefined
    }
  },
  methods: {
    eventChange (val) {
      this.$emit('onChange', val)
    }
  }
}
</script>

<style scoped lang="scss">
.custom-selectbox-theme-1 {
  border-radius: 25px;
}

</style>